import { PostHogAnalyticsProviderAdapter } from '../providers/posthog'
import { EnvironmentHelper } from '../../enviromentHelper'

export const makePostHogProvider = {
  posthog: () => {
    if (typeof window === 'undefined') {
      return null
    }

    const posthogInstance = window.posthog

    if (!posthogInstance) {
      if (!EnvironmentHelper.isProduction()) {
        // eslint-disable-next-line no-console
        console.log('PostHog instance not found. Analytics will be disabled.')
      }
      return null
    }

    return new PostHogAnalyticsProviderAdapter(posthogInstance)
  },
}
